import React from "react";
import { Col } from "react-bootstrap";

const InfoItem = ({
  label,
  value,
  children,
  col = { lg: 2, md: 3, sm: 6, xs: 12 },
  classname = "",
}) => {
  return (
    <Col {...col} className={classname}>
      <h6 className="label">{label}</h6>
      {children ? children : <h6 className="value">{value || "-"}</h6>}
    </Col>
  );
};

export default InfoItem;
